
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPaths, GetStaticProps } from 'next';
import { getAllPostsPaths, getPostByslug } from '@utils/getPosts';
import { ArticleJsonLd, NextSeo } from 'next-seo';
import { React360Viewer } from 'react-360-product-viewer';
interface IPost {
    slug: string;
    title: string;
    content: string;
    date: string;
    modified: string;
    featuredImage: {
        node: {
            sourceUrl: string;
        };
    };
}
const News = (props: {
    post: IPost;
}) => {
    const { post } = props;
    const desc = post.content.replace(/(<([^>]+)>)/gi, '');
    const trimmedString = desc.substr(0, 250);
    const postDescription = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))) + ' ...';
    const postContentVideoFix = post.content.replace(/width: 1920px;/gi, 'width: 100% !important; ');
    return (<>
      <NextSeo title={`${post.title} - KNS Okna`}/>
      <ArticleJsonLd url={`https://knsokna.pl/news/${post.slug}`} title={`${post.title} - KNS Okna`} images={[post.featuredImage.node.sourceUrl]} datePublished={post.date} dateModified={post.modified} authorName="KNS Okna" publisherName="KNS Okna" 
    // publisherLogo="https://knsokna.pl/assets/img/knsokna.png"
    description={postDescription}/>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-8 lg:px-8">
        <div className="text-center">
          <img src={post.featuredImage?.node.sourceUrl} alt={post.title} className="m-auto"/>
        </div>
        <h1 className="text-4xl">{post.title}</h1>
        <hr />
        {(post.slug === 'veka-aluconnect' || post.slug === 'aluconnect') && (<div style={{ textAlign: 'center' }}>
            <React360Viewer width={640} imagesBaseUrl="/360/pvc/veka/AluConnect/" imagesCount={37} imagesFiletype="png" mouseDragSpeed={20} imageFilenamePrefix={''}/>
          </div>)}
        <div dangerouslySetInnerHTML={{ __html: postContentVideoFix }}/>
      </div>
    </>);
};
export const getStaticPaths: GetStaticPaths = async (context) => {
    const { paths: path } = await getAllPostsPaths();
    const paths = path.map((p: {
        slug: any;
        databaseId: any;
        language: {
            slug: string;
        };
    }) => ({
        params: {
            slug: `${p.slug}`,
        },
        locale: p.language.slug.toLowerCase(),
    }));
    return { paths, fallback: 'blocking' };
};
const getStaticProps: GetStaticProps = async (context) => {
    const slug = context.params?.slug as string;
    const locale = (context.locale as string) || ('PL' as string);
    const LOCALE = locale === 'cz' ? 'CS' : locale.toUpperCase();
    const { postData } = await getPostByslug(slug, LOCALE);
    const post = postData.post;
    return {
        props: {
            post,
        },
    };
};
export default News;

    async function __Next_Translate__getStaticProps__196386c4fa8__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196386c4fa8__ as getStaticProps }
  